import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';

import { AuthGuard } from './features/auth/AuthGuard';
import { ModuleWorkspacePage } from './features/modules/ModuleWorkspacePage';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { SsoCompletePage } from './pages/SsoCompletePage';
import { AppLayout } from './shared/layout/AppLayout';

/** Bọc mọi route nội bộ trong AuthGuard + AppLayout. */
function protectedElement(node: JSX.Element): JSX.Element {
  return (
    <AuthGuard>
      <AppLayout>{node}</AppLayout>
    </AuthGuard>
  );
}

const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  { path: '/sso/complete', element: <SsoCompletePage /> },
  { path: '/', element: protectedElement(<DashboardPage />) },
  { path: '/m/:code', element: protectedElement(<ModuleWorkspacePage />) },
  { path: '/404', element: <NotFoundPage /> },
  { path: '*', element: <Navigate to="/404" replace /> },
];

export const router = createBrowserRouter(routes);
